import React, { Fragment, ReactNode } from 'react';
import { classNames } from 'primereact/utils';
import { Divider, DividerProps } from './Divider';

export type DividerListProps = DividerProps & {
	children: ReactNode[];
	gap?: number;
};

export const DividerList = ({ children, className, gap = 2, ...dividerProps }: DividerListProps) => {
	const { length } = children;
	return (
		<div className={classNames(`flex flex-column gap-${gap}`, className)}>
			{children.map((node, index) => {
				const isLast = index + 1 === length;
				return (
					// eslint-disable-next-line react/react-in-jsx-scope, react/no-array-index-key
					<Fragment key={index}>
						{node}
						{!isLast && <Divider {...dividerProps} />}
					</Fragment>
				);
			})}
		</div>
	);
};
